import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  dowloadData,
  getStringToBoolean,
  getUrlPersonQr,
} from "../../../utils/functions";
import { Link } from "react-router-dom";
import { ButtonCustom } from "../../Common.styled";
import { menuOptionBO } from "../../../utils/constants";
import { useAllPersons } from "../../../hooks/BO/useAllPersons";

export const TablePerson = () => {
  const { data, isLoading: isLoadinTable } = useAllPersons();
  return (
    <>
      <ButtonCustom onClick={() => dowloadData(data, menuOptionBO?.persons)}>
        Descargar txt
      </ButtonCustom>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Disponible</TableCell>
              <TableCell>Usuario</TableCell>
              <TableCell>Link</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoadinTable ? (
              <div>
                <CircularProgress size={40} />
              </div>
            ) : (
              data?.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>
                    {getStringToBoolean(item?.created?.toString())
                      ? "No"
                      : "Si"}
                  </TableCell>
                  <TableCell>{item.email}</TableCell>

                  <TableCell>
                    <Link to={getUrlPersonQr(item.id)}>Ir a la pagina</Link>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
